import { Box, Stack, Typography } from '@mui/material';
import { selectUserRefCode } from 'entities/payment/model';
import { buildRefCodeLink, useReferralUserInfo } from 'features/tap2mine-referral';
import { cratChainNativeToken, TokenFormat, useShallowSelector } from 'shared';
import CopyField from 'shared/ui/copy-field';
import { NumberFormat } from 'shared/ui/number-format';

export const ReferralInfo = () => {
  const { data } = useReferralUserInfo();
  const refcode = useShallowSelector(selectUserRefCode);

  return (
    <Stack flex={1}>
      <Typography variant="body1" className="secondary" mb={1}>
        Your referral code
      </Typography>

      <CopyField
        displayValue={refcode || '-'}
        copyValue={buildRefCodeLink(refcode)}
        disabled={!refcode}
        successCopyMessage="Referral link copied"
        border="1px solid"
        borderColor={(theme) => theme.themeColors.colorsCardBorder}
        maxWidth={{ xs: '100%', sm: 250, md: '100%' }}
        mb={3}
      />

      <Box>
        <Typography variant="body1" className="secondary" width="fit-content" mb={1}>
          Total earned:{' '}
          <TokenFormat
            amount={data.totalRewardAmount}
            decimals={cratChainNativeToken.decimals}
            maxDecimalDigits={2}
            variant="body1"
            symbol="CRAT"
          />
        </Typography>
      </Box>

      <Typography variant="body1" className="secondary" mb={1}>
        CPA Limit:{' '}
        <TokenFormat
          amount={data.cpaRewardAmount}
          decimals={cratChainNativeToken.decimals}
          maxDecimalDigits={0}
          variant="body1"
          symbol="CRAT"
        />
      </Typography>

      <Typography variant="body1" className="secondary">
        Total referrals: <NumberFormat variant="body1">{data.uniqueReferralCount?.toString() ?? '0'}</NumberFormat>
      </Typography>
    </Stack>
  );
};
